export default "__VITE_ASSET__8dff3d1b__"